// htmlparser2 is a reasonably large library used by the VM for interop with
// scratch-blocks, but we don't have an editor, so we can remove it entirely.

module.exports = {};
